<div class="container-fluid onetimeservices-list-wrapper mb-2 mb-md-0">
  <div class="row">
    <div class="col-12 col-md-6 col-lg-9 text-left mb-2 mb-md-0">
      <ng-container *ngIf="allWorkOrder; else buttonLoadingVisual">
        <angular2csv [data]="allWorkOrdersWithProducts" filename="{{ 'WorkOrder_Data_' + csvReportDate }}"
          [options]="csvReportOptions">
        </angular2csv>
      </ng-container>
      
      <ng-template #buttonLoadingVisual>
        <div class="loadingButtonVisual"></div>
      </ng-template>
    </div>
    <div class="col-12 col-md-6 col-lg-3">
      <app-search-input *ngIf="allWorkOrder" class="search-input text-right" [searchText]="searchText"
        (inputValue)="searchText = $event">
      </app-search-input>
    </div>
  </div>
  <div class="row">
    <div class="col">
      <ng-container *ngIf="allWorkOrder; else tableLoadingVisual">
        <app-onetimeservices-list-table 
          *ngIf="allWorkOrder" 
          [allData]="allWorkOrder" 
          [searchText]="searchText"
          [pageNumber]="tablePageNumber" 
          (openWorkOrderDetail)="redirectToWorkOrderDetails($event)">
        </app-onetimeservices-list-table>
      </ng-container>
      <ng-template #tableLoadingVisual>
        <app-table-loading-visual></app-table-loading-visual>
      </ng-template>
    </div>
  </div>
</div>